// Copyright 2025, Imprivata, Inc.  All rights reserved.

import type { TFunction } from 'i18next';

import { FactorType } from '@api/types';
import ApplicationsIcon from '../../assets/icons/applications.svg?react';
import FaceBioImg from '../../assets/icons/authenticators/face_bio.svg?react';
import IdImg from '../../assets/icons/authenticators/imprivata_ID.svg?react';
import PasswordImg from '../../assets/icons/authenticators/password.svg?react';
import PinImg from '../../assets/icons/authenticators/pin.svg?react';
import ProxCardImg from '../../assets/icons/authenticators/prox_card.svg?react';
import TempCodeImg from '../../assets/icons/authenticators/temp_code.svg?react';
import OtpImg from '../../assets/icons/authenticators/otp.svg?react';
import UsernameImg from '../../assets/icons/authenticators/username.svg?react';

const TRANSLATION_ROOT = 'self-service.authenticator-list.auth-method-info';

const mapFactorTypeToNameAndIcon = (factorType: FactorType, t: TFunction) => {
  switch (factorType) {
    case FactorType.FACE:
      return { name: t(`${TRANSLATION_ROOT}.face-recognition`), icon: <FaceBioImg /> };

    case FactorType.PROX:
      return { name: t(`${TRANSLATION_ROOT}.proximity-card`), icon: <ProxCardImg /> };

    case FactorType.PASSWORD:
      return { name: t(`${TRANSLATION_ROOT}.password`), icon: <PasswordImg /> };

    case FactorType.PIN:
      return { name: t(`${TRANSLATION_ROOT}.pin`), icon: <PinImg /> };

    case FactorType.USERNAME:
      return { name: t(`${TRANSLATION_ROOT}.username`), icon: <UsernameImg /> };

    case FactorType.TEMP_CODE:
      return { name: t(`${TRANSLATION_ROOT}.temporary-code`), icon: <TempCodeImg /> };

    case FactorType.OTP:
      return { name: t(`${TRANSLATION_ROOT}.otp`), icon: <OtpImg /> };

    case FactorType.IMPRIVATA_ID:
      return { name: t(`${TRANSLATION_ROOT}.imprivata-id`), icon: <IdImg /> };

    case FactorType.LEARNED_CREDS:
      return { name: t(`${TRANSLATION_ROOT}.learned-credentials`), icon: <ApplicationsIcon /> };

    default:
      return { name: factorType, icon: <UsernameImg /> };
  }
};

export default mapFactorTypeToNameAndIcon;
